require('angular').module('wowApp.shop')
    .service('HelpPageDeliveryService', ['$rootScope', 'Restangular', 'TrolleyService', 'AddressService', 'SettingsService', '$timeout', '$log', require('./help-page-delivery-service')])
    .directive('bwsClickAndCollect', ['AtmService', 'ShopLocatorService', 'StorePickerService', 'BwsNotificationService', require('./click-and-collect-directive.js')])
    .directive('bwsDeliveryHelpPage', ['ShopLocatorService', 'StorePickerService', 'HelpPageDeliveryService', 'StorePickerPanelService', 'AtmService', 'DeliveryService', 'CurrentUserService', 'ShopperService', '$state', 'BwsNotificationService', 'SettingsService', require('./delivery-directive.js')]);


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/help/index.js
 **/